<template>
    <div class="setup-content contact-info" id="step-7">

        <div class="form-row justify-content-between">
            <div>
                <h3 class="color-darkblue">Review & Submit</h3>
            </div>
            <div v-if="viewAllfields" class="verified-checkbox mr-4">
                <div class="form-group row claim-verified-checkbox pt-7">
                    <label for="summary_section_verified" class="control-label claim-mr-2">Verified:</label>
                    <input type="checkbox" v-model="section_verified" :disabled="disableAllFields" name="summary_section_verified" id="summary_section_verified" />
                </div>
            </div>
        </div>
        <div class="order-summary mt-1">
            <div class="row">
                <div class="col-md-12">
                    <div class="bg-white radius-5 p-3">
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr class="table-primary">
                                    <th class="text-center">SUMMARY</th>
                                    <th class="text-center">Requested</th>
                                    <th class="text-center">Adjusted</th>
                                    <th class="text-center">Approved</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-secondary">
                                    <td class="text-center">Total {{ labor_spelling }}</td>
                                    <td class="text-center">$ {{ amountFormat(totalLaborRequested) }}</td>
                                    <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalLaborAdjusted, 2, 'total') }}</td>
                                    <td class="text-center">$ {{ amountFormat(totalLaborApproved) }}</td>
                                </tr>
                                <tr class="table-secondary">
                                    <td class="text-center">Total Parts</td>
                                    <td class="text-center">$ {{ amountFormat(totalPartsRequested) }}</td>
                                    <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalPartsAdjusted, 2, 'total') }}</td>
                                    <td class="text-center">$ {{ amountFormat(totalPartsApproved) }}</td>
                                </tr>
                                <tr class="table-secondary">
                                    <td class="text-center">Total Other Charges</td>
                                    <td class="text-center">$ {{ amountFormat(totalOtherChargesRequested) }}</td>
                                    <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalOtherChargesAdjusted, 2, 'total') }}</td>
                                    <td class="text-center">$ {{ amountFormat(totalOtherChargesApproved) }}</td>
                                </tr>
                                <tr class="table-secondary">
                                    <td class="text-center">Claim Grand Total</td>
                                    <td class="text-center">$ {{ amountFormat(grandTotalRequested) }}</td>
                                    <td class="text-center">$ {{ formatNegativeValueWithParentheses(grandTotalAdjusted, 2, 'total') }}</td>
                                    <td class="text-center">$ {{ amountFormat(grandTotalApproved) }}</td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                </div>
                <div class="col-md-12">
                    <h2>Acknowledgement</h2>
                    <div class="col pl-0">
                        <div class="form-group d-flex legal_notice_checbox mb-1">
                            <input :disabled="disableAllFields || loadAllDealers" class="mr-2 align-self-start mt-1" type="checkbox" v-model="agree_legal" name="agree_legal" id="agree_legal" />
                            <label class="form-check-label" for="agree_legal" style="color: black;font-size: 14px;">
                                I hereby confirm that the information provided is accurate and complete to the best of my knowledge. 
                                I understand that this warranty claim is subject to the terms and conditions outlined in the 
                                RIZON DEALER SERVICE POLICY & WARRANTY CLAIM PROCEDURE MANUAL. 
                                I agree to notify RIZON Warranty promptly should there be any changes to this information.
                            </label>
                        </div>
                        <div v-if="loadAllDealers && agree_legal && acknowledgement_at && acknowledgement_by" class="d-flex mt-4">
                            <p class="mb-1 mr-5 ml-4"><b>Acknowledged By : {{ acknowledgement_by }}</b></p>
                            <p class="mb-1"><b>Acknowledged At : {{ acknowledgement_at }}</b></p>
                        </div>
                        <div class="field-error ml-1">{{ agree_legal_error_msg }}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

export default {
    name: "EvSummaryTab",
    mixins: [commonMixins],
    props: {
        viewAllfields: {
            type: Boolean,
            default: false
        },
        disableAllFields: {
            type: Boolean,
            default: false
        },
        loadAllDealers: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        section_verified: false,
        totalLaborRequested: 0,
        totalLaborAdjusted: 0,
        totalLaborApproved: 0,
        totalPartsRequested: 0,
        totalPartsAdjusted: 0,
        totalPartsApproved: 0,
        totalOtherChargesRequested: 0,
        totalOtherChargesAdjusted: 0,
        totalOtherChargesApproved: 0,
        grandTotalRequested: 0,
        grandTotalAdjusted: 0,
        grandTotalApproved: 0,
        agree_legal: false,
        agree_legal_error_msg: '',
        summaryId: '',
        acknowledgement_at: '',
        acknowledgement_by: '',
        initialSummaryData: '',
        currentSummaryData: ''
    }),
    mounted() {

    },
    methods: {
        validateSummaryFields(){
            var success = true;
            this.agree_legal_error_msg = '';
            if(this.agree_legal == "" || this.agree_legal == false){
                this.agree_legal_error_msg = "You must agree to all the legal requirements to proceed.";
                success = false;
            }
            return success;
        },
        emitDataToParent(flag = null) {
            var self = this;
            const dataToSend = {
                verified: self.section_verified,
                totalLaborRequested: self.totalLaborRequested,
                totalLaborAdjusted: self.totalLaborAdjusted,
                totalLaborApproved: parseFloat(self.totalLaborApproved).toFixed(2),
                totalPartsRequested: self.totalPartsRequested,
                totalPartsAdjusted: self.totalPartsAdjusted,
                totalPartsApproved: self.totalPartsApproved,
                totalOtherChargesRequested: self.totalOtherChargesRequested,
                totalOtherChargesAdjusted: self.totalOtherChargesAdjusted,
                totalOtherChargesApproved: self.totalOtherChargesApproved,
                grandTotalRequested: self.grandTotalRequested,
                grandTotalAdjusted: self.grandTotalAdjusted,
                grandTotalApproved: parseFloat(self.grandTotalApproved).toFixed(2),
                agreeLegal: self.agree_legal,
                summaryId: self.summaryId
            };

            self.$emit("send-review-data-to-parent", dataToSend, flag);
        },
        getDataFromParent(summaryData) {
            this.totalLaborRequested = summaryData.total_labor_requested_amount;
            this.totalLaborAdjusted = summaryData.total_labor_adjusted_amount;
            this.totalLaborApproved = summaryData.total_labor_approved_amount;
            this.totalPartsRequested = summaryData.total_part_requested_amount;
            this.totalPartsAdjusted = summaryData.total_part_adjusted_amount;
            this.totalPartsApproved = summaryData.total_part_approved_amount;
            this.totalOtherChargesRequested = summaryData.total_other_charges_requested_amount;
            this.totalOtherChargesAdjusted = summaryData.total_other_charges_adjusted_amount;
            this.totalOtherChargesApproved = summaryData.total_other_charges_approved_amount;
            this.grandTotalRequested = summaryData.total_requested_amount;
            this.grandTotalAdjusted = summaryData.total_adjusted_amount;
            this.grandTotalApproved = summaryData.total_approved_amount;
            this.agree_legal = summaryData.agree_legal_notice;
            this.summaryId = summaryData.id;
            this.section_verified = (summaryData.verified == 0) ? false : true;
            this.acknowledgement_at = summaryData.acknowledgement_at;
            this.acknowledgement_by = summaryData.acknowledgement_by;
            this.$nextTick(() => {
                this.populateInitialSummaryData(true);
            });
        },
        populateInitialSummaryData(flag){
            if(flag) {
                setTimeout(() => {
                    this.setInitialValue(flag);
                }, 500);
            } else {
                return this.setInitialValue(flag);
            }
        },
        setInitialValue(flag){
            const summaryData = JSON.stringify({
                agreeLegal: this.agree_legal,
            });

            if (flag) {
                this.initialSummaryData = '';
                this.initialSummaryData = summaryData;
            } else {
                this.currentSummaryData = '';
                this.currentSummaryData = summaryData;
                
                return this.initialSummaryData !== this.currentSummaryData;
            }
        },
        getLaborCalculationDataFromParent(calculationData){
            this.totalLaborRequested = calculationData.totalRequestedAmount;
            this.totalLaborApproved = calculationData.totalApprovedAmount;
            this.totalLaborAdjusted = calculationData.totalAdjustedAmount;
            this.calculateGrandTotal();
        },
        getPartCalculationDataFromParent(calculationData){
            this.totalPartsRequested = calculationData.totalRequestedAmount;
            this.totalPartsAdjusted = calculationData.totalAdjustedAmount;
            this.totalPartsApproved = calculationData.totalApprovedAmount;
            this.calculateGrandTotal();
        },
        getOtherChargesCalculationDataFromParent(calculationData){
            this.totalOtherChargesRequested = calculationData.totalRequestedAmount;
            this.totalOtherChargesAdjusted = calculationData.totalAdjustedAmount;
            this.totalOtherChargesApproved = calculationData.totalApprovedAmount;
            this.calculateGrandTotal();
        },
        calculateGrandTotal(){
            this.grandTotalRequested = 0;
            this.grandTotalAdjusted = 0;
            this.grandTotalApproved = 0;

            this.grandTotalRequested = this.totalLaborRequested + this.totalPartsRequested + this.totalOtherChargesRequested;
            this.grandTotalAdjusted = this.totalLaborAdjusted + this.totalPartsAdjusted + this.totalOtherChargesAdjusted;
            this.grandTotalApproved = this.totalLaborApproved + this.totalPartsApproved + this.totalOtherChargesApproved;
        },
        clearAllFields() {
            var self = this;
            self.section_verified = false;

            self.totalLaborRequested = 0;
            self.totalLaborAdjusted = 0;
            self.totalLaborApproved = 0;
            self.totalPartsRequested = 0;
            self.totalPartsAdjusted = 0;
            self.totalPartsApproved = 0;
            self.totalOtherChargesRequested = 0;
            self.totalOtherChargesAdjusted = 0;
            self.totalOtherChargesApproved = 0;
            self.grandTotalRequested = 0;
            self.grandTotalAdjusted = 0;
            self.grandTotalApproved = 0;

            self.agree_legal = false;
        },
    }
}
</script>
<style scoped>
.legal_notice_checbox {
    display: flex;
    align-items: center;
}

.legal_notice_checbox input[type="checkbox"] {
    margin: 0;
}

.legal_notice_checbox p {
    margin: 0 0 0 10px;
    /* Remove default margin and add left margin */
}
</style>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvSummaryTab.vue